import { useState, useEffect, useRef } from 'react';
import { callService } from "@Utils/ServiceUtils";
import { isEmpty, sha256 } from '@Views/utils/StringUtils';

const SignInPage2 = ({ msg, setSignPageNo, niceInfo, chooseOption }: any) => {

    const [idDuplicate, setIdDuplicate] = useState<boolean>(false);

    const idRef: any = useRef();
    const passwordRef: any = useRef();
    const passwordConfirmRef: any = useRef();
    const nameRef: any = useRef();
    const emailPreFixRef: any = useRef();
    const jobRef: any = useRef();

    const onClickDuplicateCheck = async () => {

        let id = idRef['current']['value'];

        if (isEmpty(id)) {
            alert('아이디를 입력해주세요.');
            idRef['current'].focus();
            return;
        }

        const regExp = /^[A-Za-z][A-Za-z0-9]{5,14}$/;
        if (!regExp.test(id)) {
            alert('아이디가 조건에 맞지않습니다.');
            idRef['current'].focus();
            return;
        }

        const params = {
            usrId: id
        }

        const res = await callService('OSUUD02R01', params);

        if (res['xistYn'] === 'N') {
            alert(msg['duplicateN']);
            setIdDuplicate(false);
        } else {
            alert(msg['duplicateY']);
            setIdDuplicate(true);
        }

    }

    const onClickNext = async () => {

        let id = idRef['current']['value'];
        let password = passwordRef['current']['value'];
        let passwordConfirm = passwordConfirmRef['current']['value'];
        let name = nameRef['current']['value'];
        let emailPrefix = emailPreFixRef['current']['value'];
        let job = jobRef['current']['value'];

        if (idDuplicate) {
            alert('아이디 중복확인을 하세요.');
            idRef['current'].focus();
            return;
        }

        // 입력 여부 체크
        if (isEmpty(id)) {
            alert('아이디를 입력해주세요.');
            idRef['current'].focus();
            return;
        }
        else if (isEmpty(password)) {
            alert('비밀번호를 입력해주세요.');
            passwordRef['current'].focus();
            return;
        }
        else if (isEmpty(passwordConfirm)) {
            alert('비밀번호 확인을 입력해주세요.');
            passwordConfirmRef['current'].focus();
            return;
        }

        else if (isEmpty(emailPrefix)) {
            alert('이메일을 입력해주세요.');
            emailPreFixRef['current'].focus();
            return;
        }

        // 패스워드 체크
        const regExpPassword = /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{9,20}$/;
        if (!regExpPassword.test(password)) {
            alert('비밀번호가 조건에 맞지않습니다.');
            passwordRef['current'].focus();
            return;
        }

        if (password !== passwordConfirm) {
            alert('비밀번호 확인이 같지않습니다.');
            passwordConfirmRef['current'].focus();
            return;
        }

        // 이메일 체크
        let email = emailPreFixRef['current']['value'];

        const regExpEmail = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
        if (!regExpEmail.test(email)) {
            alert('이메일 형식이 아닙니다.');
            emailPreFixRef['current'].focus();
            return;
        }

        // 선택 입력 여부
        if (chooseOption) {
            if (isEmpty(job)) {
                alert('직업을 입력해주세요.');
                jobRef['current'].focus();
                return;
            }
        }

        // 가입 서비스 호출
        const params = {
            usrId: id,
            ecryPwd: sha256(password),
            usrNm: name,
            cntctEaddr: email,
            ocptCd: job,
            guardian: niceInfo['guardian'],
            niceCi : niceInfo['ci']
        }

        const res = await callService('OSUUD03U01', params);

        if (res['sucsYn'] === 'N') {
            alert("에러발생");
        } else {
            setSignPageNo(3);
        }

    }


    return (
        <>
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="join-step">
                    <div className="join-step-head">
                        <div className="left">
                            <h2>회원가입</h2>
                        </div>
                        <div className="right">
                            <div className="step-status">
                                <ul className="clearfix">
                                    <li className="step-li"><span className="num">1</span> <span className="step-txt">약관동의</span></li>
                                    <li className="step-li active"><span className="num">2</span> <span className="step-txt">정보입력</span></li>
                                    <li className="step-li"><span className="num">3</span> <span className="step-txt">회원가입 완료</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="join-step-body">
                        <div className="equired">
                            <h3><strong>필수항목</strong></h3>
                            <fieldset>
                                <div className="input-group-div">
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box input-box-btn clearfix">
                                                <label htmlFor="text-1">아이디</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" id="text-1" placeholder="아이디를 입력해주세요." ref={idRef} onChange={() => { setIdDuplicate(false) }} />
                                                    <button type="button" className="btn" onClick={onClickDuplicateCheck}>{msg['duplicate']}</button>
                                                </div>
                                                <p className="input-guide text-important">영문 대소문자 숫자 6 ~15자 사용할 수 있습니다.<br />(첫자리 영문, 숫자와 혼용)</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label htmlFor="text-2">이름</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" id="text-2" value={niceInfo['name']} ref={nameRef} disabled />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label htmlFor="pw-1">비밀번호</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="password" id="pw-1" placeholder="비밀번호를 입력해주세요." ref={passwordRef} />
                                                </div>
                                                <p className="input-guide text-important">비밀번호 9자 이상 숫자, 영문, 특수문자가 각 하나이상 <br />들어가야 합니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label htmlFor="pw-2">비밀번호 확인</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="password" id="pw-2" placeholder="비밀번호를 한번 더 입력해주세요." ref={passwordConfirmRef} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box input-box-select clearfix">
                                                <label htmlFor="text-3">E-mail</label>
                                                <div className="input-group">
                                                    <input className="form-control email" type="text" id="text-3" placeholder="이메일을 입력해주세요." ref={emailPreFixRef} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div className={"optional" + (!chooseOption ? " disabled" : "")}>
                            <h3>
                                <strong>선택항목<small>*[선택]약관 동의 시 선택항목 선택하실 수 있습니다.</small></strong>
                            </h3>
                            <fieldset>
                                <div className="input-group-div">
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box input-box-select clearfix">
                                                <label htmlFor="text-3">직업</label>
                                                <div className="input-group">
                                                    <select className="form-control" disabled={!chooseOption} ref={jobRef}>
                                                        <option value="">직업선택</option>
                                                        <option value="00002">학생</option>
                                                        <option value="00004">금융인</option>
                                                        <option value="00001">회사원</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div className="btn-group btn-130">
                            <button type="button" className="btn btn-popup negative" onClick={(e) => { setSignPageNo(1) }}>뒤로</button>
                            <button type="button" className="btn btn-popup positive" onClick={onClickNext}>다음</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
export default SignInPage2;